
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/e88ada64db3193888b9a84ae586990c8/7b77d793ca7ca810cd6a3e1f07a1b509.png" 
              alt="Total Care Detailing" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4">
              Professional mobile detailing services in North Carolina. We bring the shine to you with affordable pricing and exceptional results.
            </p>
            <div className="flex items-center space-x-4">
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-line text-red-600"></i>
                </div>
                <span className="text-gray-300">Text to Book</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Full Detail</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Interior Detail</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Exterior Detail</Link></li>
              <li><Link to="/maintenance" className="text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Maintenance Plans</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-red-600 transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-red-600 transition-colors cursor-pointer">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Total Care Detailing. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-red-600 text-sm transition-colors cursor-pointer mt-2 sm:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}